"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const Rx_1 = require("rxjs/Rx");
const core_1 = require("@angular/core");
const http_1 = require("@angular/http");
const common_1 = require("../../../@inax/common");
//based on https://github.com/Valetudox/angular2-translate
let InaxTranslateService = class InaxTranslateService {
    constructor(_http, _configuration, _profileService, trans) {
        this._http = _http;
        this._configuration = _configuration;
        this._profileService = _profileService;
        this._translations = {};
        this._language = "de-DE";
        this._changeEvent = new core_1.EventEmitter();
        this.setTranslations(trans);
    }
    get defaultLanguage() {
        let lcid = sessionStorage.getItem("METADATA_LCID_DEFAULT");
        if (lcid)
            return lcid;
        return "de-DE";
    }
    set defaultLanguage(value) {
        sessionStorage.setItem("METADATA_LCID_DEFAULT", value);
    }
    get language() {
        return this._language;
    }
    set language(lng) {
        this._language = lng;
        sessionStorage.setItem("METADATA_LCID", lng);
        this._changeEvent.emit(lng);
    }
    setTranslations(value) {
        for (var lng in value) {
            if (value.hasOwnProperty(lng))
                this._translations[lng] = this.flatten(value[lng]);
        }
    }
    determineDefaultLcid() {
        this.getFirstEntryOfText().subscribe((result) => {
            if (result != null && result.SourceLcid != null)
                sessionStorage.setItem("METADATA_LCID_DEFAULT", result.SourceLcid);
        });
    }
    addTranslations(value) {
        if (this._translations != null) {
            for (var lng in value) {
                if (value.hasOwnProperty(lng)) {
                    let currentLng = this._translations[lng];
                    let flattened = this.flatten(value[lng]);
                    for (var entry in flattened) {
                        if (!currentLng.hasOwnProperty[lng]) {
                            currentLng[entry] = flattened[entry];
                        }
                    }
                }
            }
        }
        else {
            this.setTranslations(value);
        }
    }
    get ChangeEvent() { return this._changeEvent; }
    determineSupportedLanguages(forceOnline = false) {
        let lcids = sessionStorage.getItem("METADATA_LCIDS");
        if (forceOnline || lcids == null) {
            var accessUrl = this._configuration.buildRestUrl("Translation", "GetSupportedLcids");
            let headers = this._profileService.addAuthorization(new http_1.Headers());
            return this._http.get(accessUrl, { headers }).map(res => res.json());
        }
        return Rx_1.Observable.create().subscribe(() => { return lcids; });
    }
    translate(value, parameters = {}) {
        let hasEntry = (this._translations[this._language] != null && this._translations[this._language][value] != null);
        if (hasEntry) {
            let translated = hasEntry ? this._translations[this._language][value] : value;
            return this.interpolate(translated, parameters);
        }
        return value;
    }
    translateOnline(text, fromLcid = "", toLcid = "") {
        if (fromLcid == null || fromLcid.length == 0)
            fromLcid = this.defaultLanguage;
        if (toLcid == null || toLcid.length == 0)
            toLcid = this.language;
        var accessUrl = this._configuration.buildRestUrl("Translation", "Translate") + "?fromLcid=" + fromLcid + "&toLcid=" + toLcid;
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        if (text != null)
            accessUrl += "?text=" + text;
        return this._http.get(accessUrl, { headers }).map(res => res.json());
    }
    tranlsateManyOnline(texts, fromLcid = "", toLcid = "") {
        if (fromLcid == null || fromLcid.length == 0)
            fromLcid = this.defaultLanguage;
        if (toLcid == null || toLcid.length == 0)
            toLcid = this.language;
        let accessUrl = this._configuration.buildRestUrl("Translation", "TranslateMany") + "?fromLcid=" + fromLcid + "&toLcid=" + toLcid;
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.post(accessUrl, JSON.stringify(texts), { headers }).map(res => res.json());
    }
    getFirstEntryOfText(sourceText = "") {
        var accessUrl = this._configuration.buildRestUrl("Translation", "GetFirstEntryForText");
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        if (sourceText != null)
            accessUrl += "?sourceText=" + sourceText;
        return this._http.get(accessUrl, { headers }).map(res => res.json());
    }
    interpolate(str, data) {
        try {
            return str.replace(/\{ *([\w_]+) *\}/g, function (str, key) {
                var value = data[key];
                if (value === undefined) {
                    throw new Error('No value provided for variable ' + str);
                }
                else if (typeof value === 'function') {
                    value = value(data);
                }
                return value;
            });
        }
        catch (error) {
            console.error(`Error while interpolate translation '${str}' error was:${error}`);
        }
        return str;
    }
    flatten(obj) {
        var result = {};
        for (var i in obj) {
            if (!obj.hasOwnProperty(i))
                continue;
            if ((typeof obj[i]) == 'object') {
                var flatObject = this.flatten(obj[i]);
                for (var x in flatObject) {
                    if (!flatObject.hasOwnProperty(x))
                        continue;
                    result[i + '.' + x] = flatObject[x];
                }
            }
            else
                result[i] = obj[i];
        }
        return result;
    }
};
InaxTranslateService._subscribers = new Array();
InaxTranslateService = __decorate([
    core_1.Injectable(),
    __param(3, core_1.Inject('translations')),
    __metadata("design:paramtypes", [http_1.Http,
        common_1.InaxConfiguration,
        common_1.ProfileService, Object])
], InaxTranslateService);
exports.InaxTranslateService = InaxTranslateService;
